enum OnboardingBeeRequirement {
  None = 0, // eslint-disable-line no-unused-vars
  BeeRequired = 1, // eslint-disable-line no-unused-vars
  ValidatedBeeRequired = 2, // eslint-disable-line no-unused-vars
}

export default OnboardingBeeRequirement;
